import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatTabsModule } from "@angular/material/tabs";
import { NgbModule, NgbNavModule } from "@ng-bootstrap/ng-bootstrap";
import { AngularResizeEventModule } from "angular-resize-event";
import { CheckboxModule } from "primeng/checkbox";
import { RadioButtonModule } from "primeng/radiobutton";
import { DropdownModule } from "primeng/dropdown";
import { MultiSelectModule } from "primeng/multiselect";
import { TooltipModule } from "primeng/tooltip";
import { AnnotationModule } from "src/app/annotation/annotation.module";
import { SharedModule } from "../../../shared/shared.module";
import { SharedSurveyModule } from "../shared/sharedSurvey.module";
import { InsideSurveyAddressInfoFormComponent } from "./components/inside-survey/inside-survey-address-info/inside-survey-address-info-form/inside-survey-address-info-form.component";
import { InsideSurveyAddressInfoComponent } from "./components/inside-survey/inside-survey-address-info/inside-survey-address-info.component";
import { InsideSurveyBuildingLayoutCanvasComponent } from "./components/inside-survey/inside-survey-building-layout-editor/editor-canvas/layout-editor-canvas.component";
import { InsideSurveyBuildingLayoutComponent } from "./components/inside-survey/inside-survey-building-layout-editor/inside-survey-building-layout-editor.component";
import { UnsavedDialogComponent } from "./components/inside-survey/inside-survey-building-layout-editor/unsaved-dialog/unsaved-dialog.component";
import { InsideSurveyCablingProposalComponent } from "./components/inside-survey/inside-survey-cabling-proposal/inside-survey-cabling-proposal.component";
import { InsideSurveyContactInfoFormComponent } from "./components/inside-survey/inside-survey-contact-info/info-form/inside-survey-contact-info-form.component";
import { InsideSurveyContactInfoComponent } from "./components/inside-survey/inside-survey-contact-info/inside-survey-contact-info.component";
import { AccessToTelcoComponent } from "./components/inside-survey/inside-survey-inside-technical-info/access-to-telco/access-to-telco.component";
import { ExistingTelcoComponent } from "./components/inside-survey/inside-survey-inside-technical-info/existing-telco/existing-telco.component";
import { NumberControlComponent } from "./components/inside-survey/inside-survey-inside-technical-info/existing-telco/number-control/number-control.component";
import { GeneralTechnicalInfoComponent } from "./components/inside-survey/inside-survey-inside-technical-info/general-technical-info/general-technical-info.component";
import { InsideSurveyInsideTechnicalInfoComponent } from "./components/inside-survey/inside-survey-inside-technical-info/inside-survey-inside-technical-info.component";
import { NoAdminTSAComponent } from "./components/inside-survey/inside-survey-inside-technical-info/no-admin-TSA/no-admin-TSA.component";
import { SpecialBuildingInfoComponent } from "./components/inside-survey/inside-survey-inside-technical-info/special-building-info/special-building-info.component";
import { InsideSurveyInsideUnitsComponent } from "./components/inside-survey/inside-survey-inside-units/inside-survey-inside-units.component";
import { InsideUnitComponent } from "./components/inside-survey/inside-survey-inside-units/inside-unit/inside-unit.component";
import { InsideSurveyOutsideTechnicalInfoComponent } from "./components/inside-survey/inside-survey-outside-technical-info/inside-survey-outside-technical-info.component";
import { InsideSurveyOutsideUnitsComponent } from "./components/inside-survey/inside-survey-outside-units/inside-survey-outside-units.component";
import { InsideSurveyPhotoFormComponent } from "./components/inside-survey/inside-survey-photo/inside-survey-photo-form/inside-survey-photo-form.component";
import { InsideSurveyPhotoComponent } from "./components/inside-survey/inside-survey-photo/inside-survey-photo.component";
import { InsideSurveySurveyorComponent } from "./components/inside-survey/inside-survey-surveyor/inside-survey-surveyor.component";
import { InsideSurveyValidateRemarksComponent } from "./components/inside-survey/inside-survey-validate-remarks/inside-survey-validate-remarks.component";
import { InsideSurveyValidateComponent } from "./components/inside-survey/inside-survey-validate/inside-survey-validate.component";
import { InsideSurveyComponent } from "./components/inside-survey/inside-survey.component";
import { AddUnitSearchPipe } from "./services/add-unit-search.pipe";
import { BuildingLayoutService } from "./services/buildingLayout.service";

@NgModule({
  declarations: [
    InsideSurveyComponent,
    InsideSurveyAddressInfoComponent,
    InsideSurveyPhotoComponent,
    InsideSurveyCablingProposalComponent,
    InsideSurveyOutsideUnitsComponent,
    InsideSurveyInsideUnitsComponent,
    InsideSurveyOutsideTechnicalInfoComponent,
    InsideSurveyInsideTechnicalInfoComponent,
    InsideSurveyContactInfoComponent,
    InsideSurveySurveyorComponent,
    InsideSurveyAddressInfoFormComponent,
    InsideSurveyPhotoFormComponent,
    NoAdminTSAComponent,
    InsideSurveyBuildingLayoutComponent,
    InsideSurveyBuildingLayoutCanvasComponent,
    UnsavedDialogComponent,
    InsideUnitComponent,
    InsideSurveyContactInfoFormComponent,
    InsideSurveyValidateComponent,
    InsideSurveyValidateRemarksComponent,
    GeneralTechnicalInfoComponent,
    ExistingTelcoComponent,
    NumberControlComponent,
    AccessToTelcoComponent,
    AddUnitSearchPipe,
    SpecialBuildingInfoComponent,
  ],
  imports: [
    CommonModule,
    NgbModule,
    NgbNavModule,
    FormsModule,
    ReactiveFormsModule,
    AnnotationModule,
    AngularResizeEventModule,
    SharedModule,
    SharedSurveyModule,
    CheckboxModule,
    MultiSelectModule,
    DropdownModule,
    TooltipModule,
    MatTabsModule,
    RadioButtonModule,
  ],
  providers: [BuildingLayoutService],
  entryComponents: [UnsavedDialogComponent],
})
export class InsideSurveyModule {}
